<template>
    <div id="app">
        <router-view></router-view>
        <div v-if="waitingWorker" class="notification is-warning update-prompt">
            <span>Достапна е нова верзија.</span>
            <button class="button is-small is-dark" :class="{'is-loading': updating}" @click="applyUpdate">Освежи</button>
        </div>
    </div>
</template>
<script>

    export default {
        data() {
            return {
                waitingWorker: null,
                updating: false
            }
        },
        computed: {
            isAuthenticated() {
                return this.$store.getters.isAuthenticated;
            }
        },
        watch: {
            // Logging in doesn't reload the page, so the catalog is fetched again here;
            // otherwise only what the boot fetch got before login (a 401) would be there.
            isAuthenticated(authenticated) {
                if (authenticated) this.fetchCatalog();
            }
        },
        created() {
            if (this.isAuthenticated) this.fetchCatalog();
            this.$store.dispatch("pingFiscalServer");
            window.addEventListener("sw-updated", this.onUpdateAvailable);
        },
        beforeDestroy() {
            window.removeEventListener("sw-updated", this.onUpdateAvailable);
        },
        methods: {
            fetchCatalog() {
                this.$store.dispatch("getProducts");
                this.$store.dispatch("getSizes");
                this.$store.dispatch("getTypes");
                this.$store.dispatch("getCities");
            },
            onUpdateAvailable(event) {
                this.waitingWorker = event.detail.waiting;
            },
            applyUpdate() {
                // The worker activates, controllerchange fires and registerServiceWorker reloads the page.
                this.updating = true;
                this.waitingWorker.postMessage({type: "SKIP_WAITING"});
            }
        }
    }
</script>
<style>
    .update-prompt {
        position: fixed;
        bottom: 1rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1000;
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 0.75rem 1rem;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
</style>
